export default __webpack_public_path__ + "static/media/white-draw-measure-icon.474c3e9e.svg";